import * as THREE from 'three'
import Experience from '../../Experience'
import Building from './Building'

export default class Buildings {
    constructor(_options) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.ressources = this.experience.ressources
        this.time = this.experience.time
        // 
        this.targetPos = _options.targetPos
        this.materials = _options.materials

        // 
        this.buildings = []
        this.createdColumns = new Set()

        // $Debug
        this.setDebug()


    }

    setDebug() {

    }
    destroy() {
        // Détruire chaque building
        this.buildings.forEach(building => {
            if (building.destroy) {
                building.destroy()
            } else if (building.mesh) {
                this.scene.remove(building.mesh)
                building.mesh.geometry?.dispose?.()
                if (Array.isArray(building.mesh.material)) {
                    building.mesh.material.forEach(m => m.dispose?.())
                } else {
                    building.mesh.material?.dispose?.()
                }
            }
        })

        // Vider les collections
        this.buildings = []
        this.createdColumns.clear()

        // Supprimer les références
        this.experience = null
        this.scene = null
        this.ressources = null
        this.time = null
        this.targetPos = null
        this.materials = null
    }

    createBuildingsColum(positionX) {
        const position = new THREE.Vector3(positionX, (Math.random() * 2 + 1.8), -2)
        const position2 = new THREE.Vector3(positionX, (Math.random() * 2 + 1.8), -3.5)
        const position3 = new THREE.Vector3(positionX, (Math.random() * 2 + 1.8), -5)
        // 
        const building1 = new Building(position, this.ressources.items.batiment.scene, this.materials)
        const building2 = new Building(position2, this.ressources.items.batiment.scene, this.materials)
        const building3 = new Building(position3, this.ressources.items.batiment.scene, this.materials)
        this.buildings.push(building1, building2, building3)
    }
    update() {

        // this.buildings.forEach((b) => {
        //     b.update()
        // })
        const roundedX = Math.round(this.targetPos.x + 4)

        if (!this.createdColumns.has(roundedX)) {
            if (Math.random() < 0.4) {
                this.createdColumns.add(roundedX)

            }
            else {
                this.createdColumns.add(roundedX)
                this.createBuildingsColum(roundedX)
            }


        }


    }

}